export const langMap = {
  en: 'en-US',
  'zh-Hant': 'zh-TW',
  de: 'de_DE',
  th: 'th-TH',
  fr: 'fr_FR',
  id: 'id-ID',
  ja: 'ja-JP',
  ko: 'ko_KR',
  pt: 'pt_BR',
  es: 'es'
};

export const titleWithI18n: Record<keyof typeof langMap, string> = {
  de:
    'Verbinde dich mit mir im MARVEL SNAP Webshop, indem du den {{ReferralCode}} eingibst. Lass uns gemeinsam noch mehr Belohnungen sichern!',
  en:
    'Connect with me on the MARVEL SNAP Webshop by inputting {{ReferralCode}} and we will earn more rewards together!',
  es:
    'Conéctate conmigo en la tienda web de MARVEL SNAP introduciendo el {{ReferralCode}} y obtengamos más recompensas juntos.',
  fr: `Connecte-toi avec moi sur la boutique en ligne de MARVEL SNAP en saisissant {{ReferralCode}} et nous gagnerons plus de récompenses ensemble !`,
  id:
    'Terhubunglah denganku di Toko Web MARVEL SNAP dengan memasukkan {{ReferralCode}} dan kita akan mendapatkan lebih banyak hadiah bersama!',
  ja:
    'MARVEL SNAPウェブショップに {{ReferralCode}} を入力して私のアカウントと接続し、一緒にもっとたくさんの報酬を獲得しましょう！',
  ko:
    '{{ReferralCode}} 코드를 입력하고 마블스냅 웹 상점에서 연동해 주세요. 함께 더 풍성한 보상을 얻을 수 있어요!',
  pt:
    'Conecte-se comigo na loja virtual do MARVEL SNAP inserindo {{ReferralCode}} e vamos ganhar mais recompensas juntos!',
  th:
    'เชื่อมต่อกับฉันในร้านค้าบนเว็บ MARVEL SNAP โดยการใส่รหัส {{ReferralCode}} แล้วเราจะได้รับรางวัลร่วมกัน!',
  'zh-Hant': '在《漫威：瞬戰超能》網路商店與我連結，輸入{{ReferralCode}}攜手贏得豐厚獎勵！'
};

export const descWithI18n: Record<keyof typeof langMap, string> = {
  de:
    'MARVEL SNAP ist ein rasanter Card Battler. Im Spiel kannst du dein eigenes Superheldenteam aus Charaktere aus dem Marvel-Multiversum aufbauen. Das Spiel ist einfach und unkompliziert, ohne numerisches Wachstum. Lade einfach das Spiel herunter! Und genieße ein 5-minütiges spannendes PVP-Duell, in dem es um Intelligenz, Mut und Glück geht.',
  en:
    'MARVEL SNAP is a fast-paced card battle game. In the game, you will be able to choose members from the Marvel multiverse to build your own super hero team.The game is simple and straightforward, with no numerical growth. Just download the game! And enjoy a 5-minute exciting PVP duel of intelligence, courage and luck.',
  es:
    'MARVEL SNAP es un juego de batalla de cartas superrápido en el que podrás elegir miembros del multiverso de Marvel para crear tu propio equipo de superhéroes. El juego es simple y directo, sin crecimiento numérico. ¡Descárgalo ya! Y disfruta de un emocionante duelo JcJ de 5 minutos de inteligencia, valor y suerte.',
  fr: `MARVEL SNAP est un jeu de bataille de cartes palpitant. Choisissez parmi les personnages du multivers Marvel pour constituer votre propre équipe de super-héros. Le jeu est simple et facile à prendre en main. Téléchargez-le et vous ferez l'expérience de duels JcJ de 5 minutes mettant votre intelligence, votre courage et votre chance à l'épreuve.`,
  id:
    'MARVEL SNAP adalah battle game dengan ritme cepat. Di game ini, kamu bisa memilih karakter dari multiverse Marvel untuk membentuk tim super hero favoritmu. Game ini sangat simple dan mudah tanpa penghitungan angka yang rumit. Download game-nya sekarang dan nikmati duel PVP 5 menit yang melibatkan kecerdasan, keberanian dan keberuntungan!',
  ja:
    'MARVEL SNAP は極めて速いペースで行われるカードバトルゲームです。ゲーム内ではマーベルの世界からヒーローたちを選び抜いて自分だけのチームを構成できます。ゲーム自体は至極単純で、面倒な数式も演算も必要ありません。ダウンロードしてすぐ遊べます！5分あれば楽しめる運と勇気と頭脳をぶつける PVP デュエルを堪能しましょう！',
  ko:
    '마블스냅은 빠르게 진행되는 카드 배틀 게임입니다. 게임 내에서 마블 멀티버스의 캐릭터들을 선택하여 나만의 슈퍼히어로 팀을 구성할 수 있습니다. 수치적 성장이 없어 간단하고 직관적입니다. 지금 바로 게임을 다운로드하고 5분간 진행되는 치열한 PVP 결투를 즐겨 보세요! 지력, 용기, 운을 시험해 볼 시간입니다.',
  pt:
    'MARVEL SNAP é um jogo frenético de batalha com cartas. Nele, você poderá escolher membros do Multiverso da Marvel para montar sua própria equipe de super-heróis. O jogo é simples, direto e balanceado — é só baixar! E divirta-se com um emocionante duelo de 5 minutos que coloca sua inteligência, coragem e sorte contra outro jogador à prova.',
  th:
    'MARVEL SNAP เป็นเกมดวลการ์ดที่เดินเกมอย่างรวดเร็ว ในเกมนี้ คุณจะได้เลือกสมาชิกจากมาร์เวลมัลติเวิร์สเพื่อสร้างทีมซูเปอร์ฮีโร่ของคุณเอง เกมมีรูปแบบเข้าใจง่ายและตรงไปตรงมาโดยไม่ต้องพึ่งการเติบโตของตัวเลข เพียงแค่ดาวน์โหลดเกม! และสนุกไปกับการต่อสู้แบบ PVP อันน่าตื่นเต้นนาน 5 นาทีเพื่อประลองไหวพริบ ความกล้า และดวง',
  'zh-Hant':
    '《漫威：瞬戰超能》，節奏明快的卡牌對戰遊戲。在遊戲中，玩家會挑選來自漫威多重宇宙的成員，打造專屬自己的超級英雄團隊。遊玩機制簡單直白，沒有戰力養成要素。立即下載遊戲！享受鬥智鬥勇鬥運氣的5分鐘精彩PVP對決。'
};

export const posterImageWithI18n: Record<keyof typeof langMap, string> = {
  en:
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_10_22_09_42_19/poster-en_s516042.jpg',
  ja:
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_10_22_09_42_19/poster-ja_s514246.jpg',
  ko:
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_10_22_09_42_20/poster-ko_s512367.jpg',
  'zh-Hant':
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_10_22_09_42_22/poster-tw_s514362.jpg',
  de:
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_10_22_09_42_21/poster-de_s515757.jpg',
  es:
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_10_22_09_42_19/poster-es-LA_s514353.jpg',
  fr:
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_10_22_09_42_20/poster-fr_s514097.jpg',
  id:
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_10_22_09_42_19/poster-id_s515038.jpg',
  pt:
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_10_22_09_42_23/poster-pt_s517073.jpg',
  th:
    'https://p19-marketing-va.bytedgame.com/obj/g-marketing-assets-va/2024_10_22_09_42_23/poster-th_s505086.jpg'
};
